import React, { useEffect } from "react";
import { Formik } from "formik";
import { SignUpSchema } from "../utils/formik-schema/signupSchema";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Input from "./Input";
import {
  clearError,
  selectError,
  selectLoading,
  signUp,
} from "../redux/auth/authSlice";
import { getAdminById, selectAdmin } from "../redux/admin/adminSlice";

const initialValues = {
  name: "",
  email: "",
  password: "",
  role: "",
};

function SignUpForm({ setShow }) {
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const admin = useSelector(selectAdmin);
  const dispatch = useDispatch();

  const handleSignUp = async (values) => {
    dispatch(signUp(values));
    if (!error) {
      setShow(false);
    }
    values.name = "";
    values.email = "";
    values.password = "";
    values.role = "";
  };

  useEffect(() => {
    dispatch(getAdminById());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  return (
    <div>
      <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center w-full overflow-y-auto bg-black/30 backdrop-blur-sm md:inset-0 h-modal md:h-full">
        <div className="sm:w-[50%] w-full h-[70vh] bg-white rounded-lg shadow-lg text-black flex flex-col justify-center items-center p-8">
          <p className="mb-3 text-4xl font-bold tracking-wide text-gray-800">
            Create an Account
          </p>
          <p className="text-lg text-gray-600">Enter your information</p>
          <Formik
            initialValues={initialValues}
            validationSchema={SignUpSchema}
            onSubmit={handleSignUp}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => (
              <form
                className="flex flex-col justify-center w-full space-y-4"
                onSubmit={handleSubmit}
              >
                <Input
                  name="name"
                  type="text"
                  placeholder="Enter your name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.name}
                  touched={touched.name}
                  className="p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
                />
                <Input
                  name="email"
                  type="email"
                  placeholder="Enter your email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.email}
                  touched={touched.email}
                  className="p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
                />
                <Input
                  name="password"
                  type="password"
                  placeholder="Enter your password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.password}
                  touched={touched.password}
                  className="p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
                />
                <select
                  className="pt-5 border-b border-gray-300 rounded-lg focus:border-blue-500"
                  name="role"
                  value={values.role}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <option value="">Select Role</option>
                  <option value="administrator">Administrator</option>
                </select>

                <div className="flex justify-between pt-6">
                  <button
                    className="px-6 py-2 my-2 text-white transition duration-300 bg-red-500 border rounded-md hover:bg-red-600"
                    type="button"
                    onClick={() => setShow(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className={`px-6 py-2 my-2 text-white rounded-md 
                    ${
                      loading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-500 hover:bg-blue-600"
                    } 
                    transition duration-300`}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create"}
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default SignUpForm;
